import axios from "axios";

const base_url = process.env.REACT_APP_BASE_URL; //dev //TODO: MAKE ENV NAME
const base_url_saas = process.env.REACT_APP_SAAS_BASE_URL; //dev //TODO: MAKE ENV NAME
const UPLOADED_FILE_URL = process.env.REACT_APP_IMG_BASE_URL;
const ENCRYPT_KEY = process.env.REACT_APP_ENCRYPT_KEY;

const getImageBaseUrl = async () => {
    try {
        const response = await axios.get(`https://api.gamerji.tech/api/bucket/url`);
        return { success: true, data: response.data };
    } catch (error) {
        return {
            success: false,
            message: error?.response?.data?.message || "An error occurred",
            status: error?.response?.status || 500,
        };
    }
};

let imageBaseUrl = ""; // Default fallback value
const initializeS3BaseUrl = async () => {
    const s3_base_url_new = await getImageBaseUrl();
    if (!s3_base_url_new.success) {
        console.error("Error fetching S3 base URL:", s3_base_url_new.message);
        return "";
    }
    console.log("S3 Base URL fetched successfully:", s3_base_url_new.data);
    imageBaseUrl = s3_base_url_new.data.url;
    return imageBaseUrl;
};

// Initialize the S3 base URL asynchronously
const initializeBaseApis = async () => {
    const s3BaseUrl = await initializeS3BaseUrl();
    base_apis.imageUrl = `${s3BaseUrl}/`;
    url.IMAGE_URL = `${s3BaseUrl}/`;
};
// Call the initialization function
initializeBaseApis();
export var url = {
    BASE_API_URL: base_url,
    SAAS_API_URL: base_url_saas,
    IMAGE_URL: UPLOADED_FILE_URL,
    ENCRYPT_KEY: ENCRYPT_KEY,
};

export const base_apis = {
    login: `${base_url}login`,
    banner: `${base_url}banner`,
    contest: `${base_url_saas}contest`,
    tournament: `${base_url_saas}tournaments`,
    gamerjiTournament: `${base_url_saas}gamerjiTournament`,
    contestList: `${base_url_saas}contest/list`,
    contestPrizePool: `${base_url_saas}contest/getPrizePool`,
    freeGame: `${base_url}html5-settings`,
    allGame: `${base_url_saas}games`,
    gameType: `${base_url_saas}gameTypes`,
    howToJoin: `${base_url}howToJoin`,
    freeAvatar: `${base_url}avatars/free-avatars`,
    ftProfileUpdate: `${base_url}profile/verification`,
    user: `${base_url}user`,
    userInGameName: `${base_url_saas}ingamename`,
    walletLimit: `${base_url}user/walletLimit`,
    contestJoin: `${base_url_saas}joinUserContest/join`,
    tournamentInfo: `${base_url_saas}tournaments/tournamentInfo`,
    tournamentRound: `${base_url_saas}tournaments/tournamentRounds`,
    tournamentLeaderBoard: `${base_url_saas}tournaments/leaderBoard`,
    uploadSS: `${base_url}tickets/upload`,
    promoCode: `${base_url}promo-code`,
    scrim: `${base_url_saas}scrim`,
    tournamentTableImage: `${base_url_saas}tournaments/getTableImage`,
    tournamentRules: `${base_url_saas}tournaments/getRules`,
    joinUserContest: `${base_url_saas}joinUserContest`,
    imageUrl: UPLOADED_FILE_URL,// Placeholder, will be updated after initialization
    rewardCategory: `${base_url}reward-categories`,
    rewardProduct: `${base_url}reward-products`,
    getByToken: `${base_url}user-frontend/getByToken`,
    account: `${base_url}account`,
    dailyRewards: `${base_url}daily-rewards`,
    page: `${base_url}page`,
    coinStores: `${base_url_saas}coin-stores`,
    avatar: `${base_url}avatar`,
    transaction: `${base_url}transaction`,
    payu: `${base_url}payu`,
    subscriptionTypeList: `${base_url_saas}subscription/getSubscriptionTypeList`,
    userSubscriptionDetails: `${base_url_saas}subscription/getUserSubscriptionDetails`,
    payUHashSubcription: `${base_url}subscription/payment-hash`,
    payUCreateSubcription: `${base_url}subscription/create-payu-payment`,
    liveStream: `${base_url}live-streamings`,
    blogs: `${base_url}blogs`,
    tickets: `${base_url}tickets`,
    profile: `${base_url}profile`,
    customercare: `${base_url_saas}customercare`,
    subscription: `${base_url_saas}subscription`,
    htmlCategoryList: `${base_url}html5-categories/list`,
    htmlGamesList: `${base_url}html5-games/list`,
    htmlGameGet: `${base_url}html5-games/get`,
    htmlGameUpdateView: `${base_url}html5-games/update-view`,
    stats: `${base_url}stats`,
    level: `${base_url}level`,
    topProfileFollower: `${base_url}account`,
    
    easeBuzzHash: `${base_url}easebuzz/generateToken`,
    easeBuzzPaymentStatus: `${base_url}easebuzz/paymentStatus`,



};



